import React from "react";
import styled from "styled-components";
import { SkeletonBox, SkeletonText, SkeletonCard } from "./SkeletonBox";

/**
 * ArtistPageSkeleton - Non-animated skeleton for Artist page
 * 
 * Matches layout of:
 * - artist/content.js (Back button, avatar, artist names, description, movies grid)
 */

var Container = styled.div`
  padding: 2rem 4rem;
  padding-bottom: 0;
  min-height: 100vh;
  background-color: #121212;
`;

var HeaderRow = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
`;

var BackButtonSkeleton = styled.div`
  width: 48px;
  height: 48px;
  background-color: #262626;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
`;

var ArtistInfoSection = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -moz-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
`;

var ArtistTextSection = styled.div`
  margin-bottom: 20px;
  margin-right: 24px;
`;

var ContentGrid = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 40px;
`;

var CardWrapper = styled.div`
  width: 270px;
  min-width: 215px;
  padding: 16px;
  -webkit-flex-shrink: 0;
  -moz-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
`;

/**
 * Header with back button
 */
function HeaderSkeleton() {
    return (
        <HeaderRow>
            <BackButtonSkeleton />
        </HeaderRow>
    );
}

/**
 * Artist avatar and info skeleton
 */
function ArtistInfoSkeleton() {
    return (
        <ArtistInfoSection>
            {/* Circular avatar - 196x196 matching content.js */}
            <SkeletonBox width={196} height={196} circle />

            {/* Artist text info */}
            <ArtistTextSection>
                {/* Farsi name - h5 */}
                <SkeletonText width={180} size="xl" style={{ marginBottom: 8 }} />
                {/* English name - h5 */}
                <SkeletonText width={140} size="lg" style={{ marginBottom: 16 }} />
                {/* Description - smaller text */}
                <SkeletonText width={300} size="md" />
            </ArtistTextSection>
        </ArtistInfoSection>
    );
}

/**
 * Movies grid skeleton
 */
function MoviesGridSkeleton({ rows = 1, cols = 5 }) {
    var cards = [];
    var total = rows * cols;

    for (var i = 0; i < total; i++) {
        cards.push(
            <CardWrapper key={"card_" + i}>
                <SkeletonCard type="portrait" />
            </CardWrapper>
        );
    }

    return (
        <ContentGrid>
            {cards}
        </ContentGrid>
    );
}

/**
 * ArtistPageSkeleton - Main export
 * @param {number} rows - Number of movie rows to show
 * @param {number} cols - Number of columns per row
 */
function ArtistPageSkeleton({ rows = 1, cols = 5 }) {
    return (
        <Container>
            <HeaderSkeleton />
            <ArtistInfoSkeleton />
            <MoviesGridSkeleton rows={rows} cols={cols} />
        </Container>
    );
}

export { HeaderSkeleton, ArtistInfoSkeleton, MoviesGridSkeleton };
export default ArtistPageSkeleton;
